import React from "react"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

import globalStyles from "../../../../App.module.scss";

export default function Logrotate() {
    let config = `/var/log/my-app/*.log {
    daily
    rotate 14
    compress
    delaycompress
    missingok
    notifempty
    copytruncate
}`

    return (
        <div className={globalStyles.article}>
            <h1>logrotate</h1>

            <p>Left unmanaged, log files grow forever until they fill the disk. <b>logrotate</b> runs as a daily
                cron/systemd timer job and rotates, compresses and eventually deletes old logs according to
                config files under <b>/etc/logrotate.d/</b>.</p>

            <h3>Example config</h3>
            <pre className={globalStyles.code}><b>root@host:~#</b> nano /etc/logrotate.d/my-app</pre>

            <SyntaxHighlighter
                children={config}
                style={dracula}
                PreTag="div"
                language={'nginx'}
            />

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Directives</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>daily / weekly / monthly</b></td>
                        <td>How often to rotate</td>
                    </tr>
                    <tr>
                        <td><b>rotate 14</b></td>
                        <td>Keep 14 old copies before deleting the oldest</td>
                    </tr>
                    <tr>
                        <td><b>compress</b></td>
                        <td>gzip rotated files</td>
                    </tr>
                    <tr>
                        <td><b>delaycompress</b></td>
                        <td>Don't compress the most recently rotated file — some apps still hold it open briefly</td>
                    </tr>
                    <tr>
                        <td><b>missingok</b></td>
                        <td>Don't error if the log file is missing</td>
                    </tr>
                    <tr>
                        <td><b>notifempty</b></td>
                        <td>Skip rotation if the log file is empty</td>
                    </tr>
                    <tr>
                        <td><b>copytruncate</b></td>
                        <td>Copy the log then truncate the original in place — use when the app can't be signaled
                            to reopen its log file
                        </td>
                    </tr>
                    <tr>
                        <td><b>postrotate ... endscript</b></td>
                        <td>Run a command after rotating, e.g. sending SIGHUP to a daemon so it reopens the new
                            file (the alternative to copytruncate)
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Testing</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> logrotate -d /etc/logrotate.d/my-app <i># dry run, verbose, changes nothing</i><br/>
    <b>root@host:~#</b> logrotate -f /etc/logrotate.d/my-app <i># force a rotation now</i><br/>
            </pre>

            <p>logrotate itself is normally triggered once a day by <code>/etc/cron.daily/logrotate</code> or a
                <code> logrotate.timer</code> systemd unit — no need to schedule it yourself.</p>
        </div>
    )
}
